<template>
    <div class="ku-order-out">
        <div class="top">
            <div class="left">外卖订单</div>
            <van-search
                v-model="keys"
                shape="round"
                background="#4fc08d"
                placeholder="订单号|姓名|地址|微信号"
                @search="onSearch"
            />
        </div>
        <div class="user_name blue" @click="closeUser" v-if="user_id > 0">({{ user_name }})</div>
        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
            :immediate-check="true"
        >
            <div v-for="(item, index) in list" :key="index" @click="onShow(item)">
                <van-row class="food-list" :class="{'active': item.active}">
                    <van-col span="8" :class="{'active': item.set_meal}">{{ item.address }}</van-col>
                    <van-col span="3">{{ item.price }}</van-col>
                    <van-col span="8">
                        <span>
                            {{ item.createtime }}
                            <label class="green" v-if="item.pay_type === 1"> 卡</label>
                            <label class="green" v-if="item.coupon_price > 0"> 券</label>
                            <label class="green"> ({{ item.order_count }})</label>
                        </span>
                    </van-col>
                    <van-col span="5" style="text-align: right" v-if="item.download === 1">
                        <span v-if="item.distribution > 0" :class="{'red': item.distribution_status === 1}">
                            {{ item.distribution_status_text }} {{ item.distribution_time }}
                        </span>
                        <span v-else>已下载</span>
                    </van-col>
                    <van-col span="3" class="red" v-if="item.download === 0">未下载</van-col>
                </van-row>
                <van-row v-if="item.remarks" class="food-list remarks-row" :class="{'active': item.active}">
                    <van-col span="24" class="order-remarks">备注：{{ item.remarks }}</van-col>
                </van-row>
                <van-row class="food-list" :class="{'active': item.active}" v-show="item.active">
                    <van-col span="13">
                        <van-col span="24">
                            {{ item.mobile }} {{ item.name }}
                        </van-col>
                        <van-col span="24" class="br-1">
                        <div class="goods_for" v-for="(v, i) in item.goods" :key="i">
                            <div class="name">
                                <div class="c1">
                                    <span>{{v.goods_name}} {{v.num}}份 {{ v.price }}元</span>
                                    <label v-for="(v1, k1) in v.raise_arr" :key="k1">*{{v1[1]}}</label>
                                </div>
                                <div class="c2" v-if="v.type === 'combo'">
                                    <div class="combo" v-for="(v1, k1) in v.item" :key="k1">
                                        <span>*{{v1.goods_name}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </van-col>
                        <van-col span="24" v-if="item.remarks" class="br-1">
                            <div class="address">{{ item.remarks }}</div>
                        </van-col>
                        <van-col span="24" class="br-1">
                            <div class="address">{{ item.no }}</div>
                        </van-col>

                    </van-col>

                    <van-col span="10" class="right">
                        <span v-show="item.user" @click="onUser(item)">用户昵称：<label class="blue">{{ item.user_id > 0 ? item.user.nickname : item.name }}</label></span>
                        <span>下单方式：{{ item.source_text }}</span>
                        <span v-if="item.coupon_price > 0" class="red">优惠券：{{ item.coupon_price }}</span>
                        <span class="butt" @click="goShow(item)">订单发货</span>
                    </van-col>
                </van-row>
            </div>
        </van-list>

        <FootTab :tab-key="tabKey"></FootTab>
    </div>
</template>

<script>
import Vue from 'vue';
import {List, Col, Row, Cell, CellGroup, Search} from 'vant';
import FootTab from '@/components/foot'

Vue.use(List).use(Col).use(Row).use(CellGroup).use(Cell).use(Search);
    export default {
        name: "index",
        data() {
            return {
                tabKey: 'out_order',
                list: [],
                loading: false,
                finished: false,
                page: 0,
                keys: '',

                user_name: '',
                user_id: 0,
            }
        },
        components: {
            FootTab
        },
        mounted() {
            // this.onload()
        },
        methods: {
            onLoad() {
                this.page += 1;
                this.getList();
            },
            getList () {
                // 异步更新数据
                let that = this;
                that.$API.getOutList({
                    pack: 3,
                    page: that.page,
                    user_id: that.user_id,
                    keys: that.keys
                }).then(res => {
                    if (res.data.length > 0) {
                        res.data.forEach(vo => {
                            vo.active = false;
                            that.list.push(vo);
                        })
                    } else {
                        this.finished = true;
                    }

                    // 加载状态结束
                    this.loading = false;
                })
            },
            onShow(e) {
                this.list.forEach(item => {
                    if (item.id === e.id) {
                        item.active = !item.active;
                    } else {
                        item.active = false;
                    }
                })
            },
            onUser(item) {
                if (item.user_id > 0) {
                    this.user_name = item.user.nickname
                    this.user_id = item.user_id
                    this.page = 0
                    this.list = []
                    this.finished = false
                    this.loading = true;
                    this.onLoad()
                }
            },
            goShow(item) {
                this.$router.push({path: '/out_show', query: {id: item.id}})
            },
            closeUser() {
                this.user_id = 0
                this.page = 0
                this.list = []
                this.finished = false
                this.loading = true;
                this.onLoad()
            },
            onSearch() {
                this.page = 0
                this.list = []
                this.finished = false
                this.loading = true;
                this.onLoad()
            }
        }
    }
</script>

<style lang="less" scoped>
    .ku-order-out {
        margin-bottom: 60px;
        .top {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            background: #4fc08d;
            .left {
                line-height: 60px;
                font-size: 26px;
                padding-left: 20px;
                color: white;
            }
            .van-search {
                padding: 0 12px;
                .van-cell {
                    padding: 0;
                }
            }
        }
        .user_name {
            font-size: 26px;
            line-height: 50px;
        }
        .food-list {
            line-height: 50px;
            border-bottom: 2px solid #BAE2CD;
            .van-col {
                font-size: 24px;
                padding: 0 5px;
                text-align: left;
                &.br-1 {
                    border-top: 2px dashed #000;
                }

                &.active {
                    color: #DD5928;
                }
            }
            &.active {
                background: #ddd;
            }
            &.remarks-row {
                line-height: 36px;
                .order-remarks {
                    text-align: left;
                    text-indent: 10px;
                    color: #c62828;
                    font-weight: 600;
                    font-size: 24px;
                    background: #fff8e1;
                    padding: 6px 0;
                }
            }
            .right {
                span {
                    text-align: right;
                    display: flex;
                    justify-content: flex-end;
                    &.butt {
                        color: #fff;
                        background: #4fc08d;
                        padding: 5px 10px;
                        border-radius: 5px;
                        margin-top: 10px;
                        cursor: pointer;
                        display: inline-block;
                        float: right;
                    }
                }
            }
            .goods_for {
                .c1 {
                    label {
                        display: block;
                        line-height: 30px;
                        text-indent: 30px;
                    }
                }
            }
        }
        .food-edit {
            width: 100%;
            height: 90%;
            background: #898888;
            .top {
                padding: 40px 20px;
                width: 100%;
                height: 160px;
                .top-left {
                    width: 160px;
                    float: left;
                    /deep/ .van-uploader__preview {
                        .van-image {
                            width: 140px;
                            height: 140px;
                        }
                    }
                }
                .top-right {
                    width: 540px;
                    float: left;
                    .s1 {
                        width: 100%;
                        float: left;
                        .van-field {
                            width: 400px;
                            float: left;
                        }
                        .van-checkbox {
                            font-size: 26px;
                            margin-top: 20px;
                            float: right;
                            /deep/ .van-checkbox__icon {
                                background: #fff;
                            }
                            /deep/ .van-checkbox__label {
                                color: #fff;
                            }
                        }
                    }
                    .van-button {
                        width: 100px;
                        font-size: 24px;
                        padding: 0;
                        margin-right: 10px;
                        margin-top: 10px;
                        border-radius: 10px;
                        height: 50px;
                        background: #AAABAA;
                        border-color: #AAABAA;
                        color: #fff;
                        &:nth-child(6) {
                            margin-right: 0;
                        }
                        &.active {
                            background: #1E9B8E;
                            border-color: #1E9B8E;
                        }
                    }
                }
            }
            .center {
                width: 98%;
                margin: 0 auto;
                .van-field {
                    /deep/ .van-field__label {
                        width: 120px;
                    }
                }
                .max {
                    width: 100%;
                    position: relative;
                    min-height: 80px;
                    .van-field {
                        width: 50%;
                        height: 80px;
                        float: left;
                    }
                }
            }
            .foot-raise {
                text-align: left;
                padding: 30px 10px;
                .van-button {
                    width: 138px;
                    font-size: 24px;
                    padding: 0;
                    margin-right: 8px;
                    margin-top: 20px;
                    border-radius: 10px;
                    height: 50px;
                    background: #FFF;
                    border-color: #FFF;
                    &.active {
                        background: #1E9B8E;
                        border-color: #1E9B8E;
                        color: #fff;
                        span > span {
                            color: #C6D739;
                        }
                    }
                }
            }
            .foot-category {
                .van-button {
                    background: none;
                    color: #fff;
                }
            }
            .ku-submit {
                width: 60%;
                margin: 0 auto;
                text-align: center;
            }
        }
        .add-button {
            width: 310px;
            margin-top: 30px;
        }
    }

</style>
